// One-shot handoff for opening Capture pre-filled from the exhibitor directory
// (v0.7). An in-memory baton rather than route params: the values are transient UI
// state, not something worth putting in a URL a user could bookmark half-filled,
// and it keeps the #/capture route unchanged.
//
// CONSUMED ONCE, deliberately. renderCapture takes it and clears it, so hitting the
// Capture tab later gives a blank form instead of a stale vendor name from an
// exhibitor the user looked at twenty minutes ago. A page reload also drops it,
// which is the same outcome and equally fine.

export interface CapturePrefill {
  show: string;
  vendor_name: string;
  /** Empty for shows with no booth assignments yet (WWIN/Evolve). */
  booth_number: string;
}

let pending: CapturePrefill | null = null;

/** Arm the next Capture render. Call immediately before routing to #/capture. */
export function setCapturePrefill(p: CapturePrefill): void {
  pending = p;
}

/** Take (and clear) the pending prefill. Returns null when Capture opened normally. */
export function takeCapturePrefill(): CapturePrefill | null {
  const p = pending;
  pending = null;
  return p;
}
